module.exports = __webpack_public_path__ + "img/059-businesswoman.6931313e.png";